import React, { useState } from 'react';
import { theme, Input, Button, message } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { submitFeedback } from '../api';

const { TextArea } = Input;

const Feedback: React.FC = () => {
  const { token } = theme.useToken();
  const { user } = useAuth();
  const [feedback, setFeedback] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!feedback.trim()) {
      message.warning('Please enter your feedback');
      return;
    }

    setSubmitting(true);
    try {
      await submitFeedback({
        userId: user?.uid || '',
        userEmail: user?.email || '',
        feedback: feedback.trim(),
      });
      message.success('Thank you for your feedback!');
      setFeedback('');
    } catch (error) {
      message.error('Failed to submit feedback. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: '96px 24px 24px', maxWidth: 600 }}>
      <h1 style={{ fontSize: token.fontSizeHeading2, color: token.colorText, marginBottom: 16 }}>
        Feedback
      </h1>
      <p style={{ fontSize: token.fontSize, color: token.colorTextSecondary, lineHeight: 1.6, marginBottom: 24 }}>
        We'd love to hear your thoughts, suggestions, or any issues you've encountered. Your feedback helps us improve.
      </p>

      <TextArea
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        placeholder="Share your feedback..."
        rows={6}
        style={{
          marginBottom: 16,
          background: 'rgba(255, 255, 255, 0.05)',
          borderColor: 'rgba(255, 255, 255, 0.15)',
          color: token.colorText,
          borderRadius: 8,
        }}
      />

      <Button
        type="primary"
        onClick={handleSubmit}
        loading={submitting}
        disabled={!feedback.trim()}
      >
        Submit Feedback
      </Button>
    </div>
  );
};

export default Feedback;
